<template>
  <div>
    <el-row style="margin-top: 20px;">
      <el-form :model="selectForm" :inline="true" ref="selectForm" size="medium">
        <el-form-item label="副仓：" v-if="subWarehouseList && subWarehouseList.length">
          <el-select v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择副仓" clearable multiple collapse-tags
            style="width: 200px;">
            <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：">
          <el-select v-model="selectForm.project" filterable clearable>
            <el-option v-for="item in projects" :key="item.PROJECT_ID" :label="item.PROJECT_NAME"
              :value="item.PROJECT_ID" />
          </el-select>
        </el-form-item>
        <el-form-item label="产品编码：">
          <el-input v-model="selectForm.product_code" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户：">
          <el-select v-model="selectForm.COMPANY" filterable placeholder="请选择" clearable>
            <el-option v-for="item in companys" :key="item.value" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择日期：">
          <el-date-picker v-model="selectForm.SEND_DAY" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" :loading="loading">筛选</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="exportData">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="delStockData">删除缺货记录</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-table v-loading="loading" ref="multipleTable" :data="tableDataPage" :span-method="objectSpanMethod"
      class="tableArea" border @selection-change="handleSelectionChange" :cell-class-name="tableCellClassName"
      @cell-click="cellClick" max-height="520">
      <el-table-column type="selection" width="40" fixed="left"></el-table-column>
      <el-table-column prop="ID" label="序号" width="50">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.INDEX }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="PRODUCT_NAME" label="名称" min-width="80">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.PRODUCT_NAME }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="PRODUCT_CODE" label="编码" width="110">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.PRODUCT_CODE }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="ORDER_ID" label="订单ID" width="80">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.ORDER_ID }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="SEND_DAY" label="送货日期" width="100">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.SEND_DAY }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="TC_NAME" label="团餐公司" width="120">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.TC_NAME }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="PROJECT_NAME" label="项目点" width="100">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.PROJECT_NAME }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="DK_NAME" label="档口" width="80">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.DK_NAME }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="TYPE_UNIT" label="单位" width="40">
          <template slot-scope="scope">
            <span :style="setFontColor(scope.row)">
              {{ scope.row.TYPE_UNIT }}
            </span>
          </template>
        </el-table-column> -->
      <el-table-column prop="NEED_COUNT" label="缺货数量" width="60">
        <template slot-scope="scope">
          <span :style="setFontColor(scope.row)">
            {{ scope.row.NEED_COUNT }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="可出库产品">
        <el-table-column prop="NEW_NAME" label="产品名称" min-width="100"></el-table-column>
        <el-table-column prop="NEW_CODE" label="编码" width="120"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" width="50"></el-table-column>
        <!--          <el-table-column prop="BATCH" label="批次" width="80"></el-table-column>-->
        <el-table-column prop="BATCH" label="批次" width="150">
          <template slot-scope="scope">
            <template v-if="scope.row.modifiable == true">
              <el-select class="select-item" size="medium" v-model="scope.row.BATCH" filterable clearable
                @change="editData(scope.row)" @focus="handleFocus(scope.row)">
                <el-option v-for="item in batchList" :key="item.BATCH" :label="item.BATCH" :value="item.BATCH" />
              </el-select>
            </template>
            <template v-else>
              {{ scope.row.BATCH }}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="PRODUCT_PRICE" label="产品价格" width="80"></el-table-column>
        <el-table-column prop="PRODUCTION_DATE" label="生产日期" width="80"></el-table-column>
        <el-table-column prop="QGP" label="保质期" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
          </template></el-table-column>
        <el-table-column prop="INW_COUNT" label="库存数量" width="80"></el-table-column>
        <el-table-column prop="LOCATION_CODE" label="库位" width="80"></el-table-column>
        <el-table-column label="出库数量" width="100">
          <template slot-scope="scope">
            <el-input :ref="`lackCountInput${scope.$index}`" size="small" style="width:100%"
              v-model="scope.row.LACK_COUNT" clearable />
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="操作" v-if="fun_dic[105010102]" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" type="text" @click="modify(scope.row)">添加出库产品</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="2" :offset="22" style="margin-top:12px">
        <el-button size="small" type="default" @click="allSubmit" :disabled="allButton == 0">全部确认</el-button>
      </el-col>
    </el-row>
    <el-row :span="24" style="text-align: right;margin-top:12px">
      <el-pagination @current-change="handlePageChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </el-row>

    <el-dialog title="导出二次出库数据" center :visible.sync="导出二次出库数据模态框" width="500px">
      <span style="margin-left: 60px">日期范围:

        <el-date-picker style="width: 300px" v-model="DAY_INTERVAL" type="daterange" align="right" unlink-panels
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
          :clearable="false"></el-date-picker>

      </span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="导出二次出库数据模态框 = false">取 消</el-button>
        <el-button @click="确认导出二次出库数据()">确 定</el-button>
      </div>
    </el-dialog>


    <!-- 修改出库产品模态框 -->
    <el-dialog title="添加出库产品" :visible.sync="editFormVisible" center width="1000px" @close="closeDialog">
      <el-row style="margin-top: 20px">
        <el-col>
          <el-form size="small" :inline="true" :model="addForm" ref="addForm" class="demo-form-inline"
            style="padding: 0; margin: 0" @submit.prevent.native>
            <el-form-item label="产品名称：">
              <el-input v-model="addForm.name" @keyup.enter.native="addHandleSearch" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="addHandleSearch" :loading="loading">筛选</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <span>需出库产品：{{ addlist_row.PRODUCT_NAME }}</span>
          <span style="margin-left:20px">所需总数：{{ addlist_row.NEED_COUNT }} {{ addlist_row.TYPE_UNIT }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" stripe border style="width: 100%;margin-top: 20px">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="80"></el-table-column>
            <el-table-column prop="BATCH" label="批次" min-width="80"></el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="库存" min-width="80"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位" min-width="80"></el-table-column>
            <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="80"></el-table-column>
            <el-table-column label="数量" min-width="70">
              <template slot-scope="scope">
                <el-input size="small" v-model="scope.row.NEED_COUNT" placeholder="请输入" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="addProduct(ID, scope.row)">添加</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div class="pagination_box" style="text-align: left; margin-top: 20px">
        <el-pagination @current-change="addHandleCurrentChange" :current-page.sync="addCurrentPage"
          :page-size="addPageSize" layout="total,prev, pager, next, jumper" :total="addTotalCount" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">完成</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  setOutFontColor, secondOutQuery, secondOutMulty, queryWarehouseFun, secondOutExportFun, delData,
} from '@/assets/api/warehouseManager';
import { selectTCFun, haveXMDFun } from '@/assets/api/sellOrder';
import { frontEndFun } from '@/assets/api/frontFun';
import util from '@/assets/common/util';
import validation from '@/assets/common/validation';
import date from '@/assets/common/date';

export default {
  data () {
    return {
      DAY_INTERVAL: [],
      导出二次出库数据模态框: false,
      companys: [],
      PAGE_ID: '1050101', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 105010101: 0, 105010102: 0, 105010103: 0 }, // 功能ID 一旦规定不要轻易改动
      allButton: 1,
      loading: false,
      tableData: [],
      batchList: [],
      selectForm: {
        product_code: '',
        project: '',
        SEND_DAY: date(new Date(), '%F'),
      },
      projects: [],
      putOnArr: [],
      currentPage: 1,
      totalCount: 0,
      tableDataPage: [],
      // loading1:false
      spanArr: [],
      position: 0,
      editFormVisible: false,
      searchForm: {},
      addTotalCount: 0,
      addPageSize: 20,
      addCurrentPage: 1,
      addlist_row: {},
      addForm: {},
      ID: '',
      rowIndex: '',
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
    };
  },
  computed: {
    inwCountObj () {
      return this.tableDataPage.reduce((obj, cur) => {
        if (!(cur.ID in obj)) {
          obj[cur.ID] = 0;
        }
        obj[cur.ID] += Number(cur.INW_COUNT);
        return obj;
      }, {});
    },
  },
  inject: ['reload'],
  created () {
    this.queryBeforeFun();
    this.handleSearch();
    this.queryProject();
    this.querySupplier();
    // let tempArr  = JSON.parse(sessionStorage.getItem('tmpArr'))
  },
  methods: {
    // 取得对应行的index
    tableCellClassName ({
      row, column, rowIndex, columnIndex,
    }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    cellClick (row, column, cell, event) {
      this.rowIndex = row.index;
    },
    // --------------------------行
    rowspan () {
      this.tableDataPage.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else if (this.tableDataPage[index].ID === this.tableDataPage[index - 1].ID) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    // ---------------------------------表格合并行
    objectSpanMethod ({
      row, column, rowIndex, columnIndex,
    }) {
      if ([0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(columnIndex)) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    // 增加一条新的数据
    addProduct (id, row) {
      if (!row.NEED_COUNT || row.NEED_COUNT == '') {
        this.$message.show({ text: '请输入出库数量', type: 'warning' });
        return false;
      }
      if (util.JudgmentUnit(row.TYPE_UNIT)) {
        if (!validation.数量正数验证(row.NEED_COUNT)) {
          this.$message.show({ text: '请输入正数出库数量', type: 'warning' });
          return false;
        }
      } else if (!validation.数量整数正数验证(row.NEED_COUNT)) {
        this.$message.show({ text: '请输入正整数出库数量', type: 'warning' });
        return false;
      }
      if (row.NEED_COUNT) {
        let tag = true;
        const data = {
          ...this.addlist_row,
          ADDED: 0,
          BATCH: row.BATCH,
          ENOUGH_FLAG: 1,
          QGP: Number(row.QGP),
          QGP_TIME_TYPE: Number(row.QGP_TIME_TYPE),
          ID: id,
          LOCATION_ID: row.LOCATION_ID,
          LOCATION_CODE: row.LOCATION_CODE,
          INW_COUNT: Number(row.PRODUCT_COUNT),
          LACK_COUNT: row.NEED_COUNT, // 出库数量
          TYPE_UNIT: row.TYPE_UNIT,
          COUNT: 0,
          PRODUCTION_DATE: row.PRODUCTION_DATE,
          NEW_NAME: row.PRODUCT_NAME,
          NEW_CODE: row.PRODUCT_CODE,
        };
        for (let i = 0; i < this.tableDataPage.length; i++) {
          if (data.BATCH === this.tableDataPage[i].BATCH && data.ID === this.tableDataPage[i].ID) {
            this.tableDataPage[i].LACK_COUNT = Number(this.tableDataPage[i].LACK_COUNT) + Number(data.LACK_COUNT);
            tag = false;
            break;
          }
        }

        if (tag) {
          this.tableDataPage.splice(this.rowIndex, 0, data);
        }
        this.spanArr = [];
        this.rowspan();
      }
    },
    // ----------------分页
    addHandleCurrentChange () {
      this.addHandleSearch();
    },
    addHandleSearch () {
      const params = {
        PRODUCT_NAME: this.addForm.name,
        TC_ID: this.addForm.TC_ID,
        PAGESIZE: this.addPageSize,
        PAGEINDEX: this.addCurrentPage - 1,
        SHOW: 0,
        FLAG: 0,
      };
      this.loading = true;
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      queryWarehouseFun(params)
        .then((result) => {
          this.addTotalCount = result[0].TOTAL_COUNT;
          this.tableData = result[0].OP_ROLE.map((item, index) => Object.assign(item, { NEED_COUNT: '' }));
          if (result[0].TOTAL_WORTH !== '') {
            this.total_price = result[0].TOTAL_WORTH;
          } else {
            this.total_price = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    editData (row) {
      const index = this.batchList.findIndex((item) => item.BATCH === row.BATCH);
      row.PRODUCT_PRICE = this.batchList[index].PRODUCT_PRICE;
      row.PRODUCTION_DATE = this.batchList[index].PRODUCTION_DATE;
      row.INW_COUNT = this.batchList[index].PRODUCT_COUNT;
      row.LOCATION_ID = this.batchList[index].LOCATION_ID;
      row.QGP = this.batchList[index].QGP;
      row.QGP_TIME_TYPE = this.batchList[index].QGP_TIME_TYPE;
      row.LOCATION_CODE = this.batchList[index].LOCATION_CODE;
      this.$forceUpdate();
    },
    handleFocus (row) {
      this.batchList = [];
      const params = {
        PAGESIZE: 5000,
        PAGEINDEX: 0,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE: row.PRODUCT_CODE,
        SHOW: 0,
        TYPE: 0,
        FLAG: 0,
      };
      queryWarehouseFun(params).then((result) => {
        if (result[0].OP_ROLE.length != 0) {
          this.batchList = result[0].OP_ROLE;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 添加出库产品按钮
    modify (row) {
      this.toggleSelection();
      this.addlist_row = row;
      this.ID = row.ID;
      this.addForm = {
        name: '',
        TC_ID: row.TC_ID,
      };

      this.editFormVisible = true;
      this.putOnArr = [];
    },
    // 关闭模态框
    closeDialog () {
      this.editFormVisible = false;
      this.addForm = {};
      this.tableData = [];
      this.addTotalCount = 0;
      this.putOnArr = [];
    },
    // -------------------------------------客户
    querySupplier () {
      const params = {
        GET_ALL_FLAG: 1,
      };
      selectTCFun(params).then((result) => {
        if (result.length !== 0) {
          this.companys = this.$util.listRemoveDuplicates(result[0].company);
        } else {
          this.companys = [];
        }
      }).catch((error) => {
      });
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 筛选
    handleSearch () {
      this.currentPage = 1;
      this.putOnArr = [];
      this.queryData();
    },
    queryData () {
      const params = {
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
      };
      if (this.selectForm.project) {
        params.PROJECT_ID = this.selectForm.project;
      }
      if (this.selectForm.product_code) {
        params.PRODUCT_CODE = this.selectForm.product_code;
      }
      if (this.selectForm.COMPANY) {
        params.TC_ID = this.selectForm.COMPANY;
      }
      if (this.selectForm.SEND_DAY) {
        params.DELIVER_DAY = this.selectForm.SEND_DAY;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      secondOutQuery(params).then((result) => {
        if (result[0]) {
          this.tableDataPage = result[0].LIST.reduce((list, cur, ID) => {
            const ADP = JSON.parse(JSON.stringify(cur.ADP));
            delete cur.ADP;
            list.push(...ADP.map((x) => ({
              ID,
              INDEX: ID + 1,
              ...cur,
              ...x,
              NEW_NAME: cur.PRODUCT_NAME,
              NEW_CODE: cur.PRODUCT_CODE,
              PRODUCT_CODE: cur.ORDER_PRODUCT_CODE,
              PRODUCT_NAME: cur.ORDER_PRODUCT_NAME,
              NEW_TYPE_UNIT: cur.PRODUCT_TYPE_UNIT,
              NEED_COUNT: cur.LACK_COUNT,
              modifiable: cur.BATCH == 0,
              PLACE_LACK_COUNT: cur.LACK_COUNT,
            })));
            return list;
          }, []) || [];
          this.spanArr = [];
          this.rowspan();

          this.totalCount = result[0].TOTAL_COUNT || 0;
        } else {
          this.tableDataPage = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    setFontColor (row) {
      return setOutFontColor(Number(Number(row.NEED_COUNT) <= this.inwCountObj[row.ID]));
    },
    // -------------------------------------全部确认
    allSubmit () {
      if (this.putOnArr.length == 0) {
        this.$message.show({ text: '请勾选订单', type: 'warning' });
        return;
      }
      for (let i = 0; i < this.putOnArr.length; i++) {
        if (
          util.JudgmentUnit(this.putOnArr[i].TYPE_UNIT)
            ? !validation.数量正数0验证(this.putOnArr[i].LACK_COUNT)
            : !validation.数量整数正数0验证(this.putOnArr[i].LACK_COUNT)
        ) {
          this.$message.show({ text: '请输入正确数量', type: 'warning' });
          this.$refs[`lackCountInput${this.putOnArr[i].index}`].focus();
          return;
        }
      }
      const PRODUCT_ARRAY = util.listRemoveDuplicates(this.putOnArr).map((item) => ({
        LACK_RECORD_ID: item.LACK_RECORD_ID,
        LACK_COUNT: Number(item.LACK_COUNT),
        BATCH: item.BATCH,
        ORDER_DETAIL_ID: item.ORDER_DETAIL_ID,
        ORDER_ID: item.ORDER_ID,
        DK_ID: item.DK_ID,
        PROJECT_ID: item.PROJECT_ID,
        IS_SUPPLIER_CLIENT: item.IS_SUPPLIER_CLIENT,
        ENOUGH_FLAG: item.ENOUGH_FLAG,
        LOCATION_ID: item.LOCATION_ID,
        TYPE_UNIT: item.TYPE_UNIT,
        PRODUCT_CODE: item.NEW_CODE,
      }));
      const params = {
        WAREHOUSE_MODE: this.WAREHOUSE_MODE,
        PRODUCT_ARRAY,
      };
      if (PRODUCT_ARRAY.length > this.putOnArr.length) {
        params.IS_REPEATED = 1;
      }

      secondOutMulty(params).then((result) => {
        if (result[0].STILL_LACK_FLAG === 1) {
          this.$message.show({ text: '仍有商品缺货', type: 'error' });
          if (this.fun_dic[105010103]) {
            window.location.href = util.getURLLocalHost(result[0].URL);
          }
        } else {
          this.$message.show({ text: '出库成功', type: 'success' });
          if (this.fun_dic[105010103]) {
            window.location.href = util.getURLLocalHost(result[0].URL);
          }
        }
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange (e) {
      if (e.length == this.tableDataPage.length || e.length == 0) {
        this.putOnArr = e;
      } else {
        this.putOnArr = [];
        e.forEach((i, index) => {
          this.tableDataPage.forEach((item, Index) => {
            if (item.ID === i.ID) {
              // if ((item.ORDER_ID === i.ORDER_ID) && (item.PRODUCT_CODE === i.PRODUCT_CODE)) {
              this.putOnArr.push(item);
            }
          });
        });
      }
    },
    // -----------------------------------选择门店
    queryProject () {
      haveXMDFun().then((result) => {
        this.projects = result.length > 0 ? this.$util.listRemoveDuplicates(result[0].project) : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handlePageChange (page) {
      this.currentPage = page;
      this.queryData();
    },
    确认导出二次出库数据 () {
      const params = {
        START_DAY: this.DAY_INTERVAL[0],
        END_DAY: this.DAY_INTERVAL[1],
      };

      secondOutExportFun(params).then((res) => {
        if (res[0] && res[0].FILE_PATH) {
          window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
        }
      }).catch((err) => this.$message.show({ text: err, type: 'error' }));
    },
    exportData () {
      this.导出二次出库数据模态框 = true;
    },
    // 删除缺货记录
    delStockData () {
      if (this.putOnArr.length == 0) {
        this.$message.show({ text: '请勾选需要删除的缺货记录', type: 'warning' });
        return false;
      }
      this.openDelConfirm().then(() => {
        const delList = this.putOnArr.map((item, index) => item.LACK_RECORD_ID);
        const params = {
          LACK_RECORD_ID_ARRAY: delList,
        };
        delData(params).then((res) => {
          this.$message.show({ text: '删除缺货记录成功', type: 'success' });
          this.queryData();
        }).catch((err) => this.$message.show({ text: err, type: 'error' }));
      }).catch(() => {

      });
    },
    // 删除缺货记录二次确认
    openDelConfirm () {
      return this.$confirm('删除的缺货记录不可恢复，确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
    },
  },
};
</script>
<style scoped>
.el-table .warning-row {
  background: pink;
}

.tableArea {
  margin-top: 20px;
}

.lack {
  color: #f56c6c;
}

.full {
  color: #228b22;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/secondOut.vue